import { AfterViewInit, OnInit, Component, ViewChild, Input, ViewChildren, QueryList } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { WorkbenchDataView } from '../../model/Workbench-dataview';
import { NodesService } from 'src/app/component/node/service/nodes.service';
import { Router } from '@angular/router';
import { AccountRequestService } from 'src/app/component/auth/service/account-request.service';
import { WorkflowsService } from 'src/app/component/system/workflows/service/workflows.service';
import { Msg } from 'src/app/component/auth/model/user.model';
import { Node } from 'src/app/component/node/model/node.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReassignChangeNodeStateComponent } from '../../reassignchange-node/reassign-change-node-state/reassign-change-node-state.component';
import { ChangeNodeComponent } from '../../reassignchange-node/change-node/change-node.component';

const sortingDataAccessor = (item: any, property: string) => {
  switch (property) {
    case 'CREATED_DATE':
      if (item?.CREATED_DATE) return item.CREATED_DATE?.toString();
      else return '';
    case 'UPDATED_DATE':
      if (item?.lastestUpdatedDate) return item.lastestUpdatedDate?.toString();
      else return '';
    case 'FIRST_NAME':
      if (item?.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.FIRST_NAME) return item?.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.FIRST_NAME?.toString().toLocaleLowerCase();
      else return '';
    case 'LAST_NAME':
      if (item?.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.LAST_NAME) return item?.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.LAST_NAME?.toString().toLocaleLowerCase();
      else return '';
    case 'EMAIL':
      if (item?.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.EMAIL_ADDRESS) return item?.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.EMAIL_ADDRESS?.toString().toLocaleLowerCase();
      else return '';
    case 'REGION':
      if (item?.NODE_REGIONS[0]?.REGION?.CODE) return item?.NODE_REGIONS[0]?.REGION?.CODE?.toString().toLocaleLowerCase();
      else return '';
    case 'ORGANIZATION':
      if (item?.NODE_REGIONS[0]?.REGION?.ORGANIZATION?.NAME) return item?.NODE_REGIONS[0]?.REGION?.ORGANIZATION?.NAME?.toString().toLocaleLowerCase();
      else return '';
    case 'Provisional School Name':
      if (item?.NODE_PROVISIONAL_SCHOOLS[0]?.PROVISIONAL_SCHOOLS?.SCHOOL_NAME) return item?.NODE_PROVISIONAL_SCHOOLS[0]?.PROVISIONAL_SCHOOLS?.SCHOOL_NAME?.toString().toLocaleLowerCase();
      else return '';
    case 'ProvSchool_COE_NUMBER':
      if (item?.NODE_PROVISIONAL_SCHOOLS[0]?.PROVISIONAL_SCHOOLS?.CO?.COE_NUMBER) return item?.NODE_PROVISIONAL_SCHOOLS[0]?.PROVISIONAL_SCHOOLS?.CO?.COE_NUMBER?.toString().toLocaleLowerCase();
      else return '';
    case 'RECRUITER_NAME':
      if (item?.NODE_COES?.[0]?.CO?.RECRUITER_NAME) return item?.NODE_COES[0]?.CO?.RECRUITER_NAME.toString().toLocaleLowerCase();
      else return '';
    case 'CURRENT_CITY':
      if (item?.NODE_COES?.[0]?.CO?.CURRENT_CITY) return item.NODE_COES[0]?.CO?.CURRENT_CITY?.toString().toLocaleLowerCase();
      else return '';
    case 'COE_NUMBER':
      if (item?.NODE_COES?.[0]?.CO?.COE_NUMBER) return item?.NODE_COES[0]?.CO?.COE_NUMBER?.toString().toLocaleLowerCase();
      else return '';
    case 'CURRENT_EDITOR':
      if (item?.NODE_EDITING[0]?.LOGIN_DETAILS?.PERSON?.FIRST_NAME) return item?.NODE_EDITING[0]?.LOGIN_DETAILS?.PERSON?.FIRST_NAME;
      else return '';
    case 'SURVEY_ID':
      return item.NODE_COES?.[0]?.CO?.COE_SURVEY?.SURVEY_ID ?? '';
    case 'COE_ID':
      return item.NODE_COES?.[0]?.COES_ID ?? '';      
    default:
      if (item?.NodeId) return item.NodeId;
      else return '';
  }
};

@Component({
  selector: 'app-mat-table-queue',
  templateUrl: './mat-table-queue.component.html',
  styleUrls: ['./mat-table-queue.component.scss']
})

export class MatTableQueueComponent {
  @Input('dataSource') tblnodedata: WorkbenchDataView[];
  @Input() WorkflowID: number;
  @Input('workflow') workflow: any;
  @Input('state') state: any;
  @Input('no-reload') noReload: boolean;
  @Input('screenName') screenName: string;
  @Input() node!: Node;
  @ViewChild('paginator1') paginator1: MatPaginator;
  @ViewChild('sort1') sort1?: MatSort;
  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild('sort2') sort2?: MatSort;

  tableDataSources: MatTableDataSource<WorkbenchDataView>[] = [];
  displayedColumns: string[] = [];
  cdisplayedColumns: string[] = [];

  mesg: string;
  deleteLoading: boolean = false;
  deleteCoeID: number;
  routeURL: string = '';

  dataSourceSyncInitial = new MatTableDataSource<WorkbenchDataView>();
  dataSourceWithCoeNumber = new MatTableDataSource<WorkbenchDataView>();
  matTableWithCoeNumber = new MatTableDataSource<WorkbenchDataView>();

  constructor(private nodeService: NodesService, private accountRequestService: AccountRequestService, private workflowsService: WorkflowsService, private router: Router,  private dialog: MatDialog) { }

  ngOnInit(): void {
    this.cdisplayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'SURVEY_ID', 'COE_ID']
    this.generateDisplayColumns();
    this.loadUpdateDataSource();
  }

  ngAfterViewInit() {
    if (this.sort2) {
      this.dataSourceSyncInitial.sort = this.sort2;
      this.dataSourceSyncInitial.paginator = this.paginator2;
    }

    if (this.sort1) {
      this.matTableWithCoeNumber.sort = this.sort1;
      this.matTableWithCoeNumber.paginator = this.paginator1;
    }
  }

  generateDisplayColumns() {
    if (this.screenName == 'myinvolved') {
      if (this.WorkflowID == 4) { this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'FIRST_NAME', 'LAST_NAME', 'EMAIL', 'REGION', 'ORGANIZATION'] }
      else if (this.WorkflowID == 6) { this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'REGION', 'Provisional School Name', 'ProvSchool_COE_NUMBER'] }
      else { this.displayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'REGION', 'CURRENT_CITY', 'COE_NUMBER', 'SURVEY_ID', 'CURRENT_EDITOR'] }//, 'COE_NUMBER']}//, 'UPDATED_DATE', ] //, 'CURRENT_EDITOR' }
    }
    else if (this.screenName == 'myarchive') {
      if (this.WorkflowID == 4) { this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'FIRST_NAME', 'LAST_NAME', 'EMAIL', 'REGION', 'ORGANIZATION'] }
      else if (this.WorkflowID == 6) { this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'REGION', 'Provisional School Name', 'ProvSchool_COE_NUMBER'] }
      else { this.displayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'REGION', 'CURRENT_CITY', 'COE_NUMBER', 'CURRENT_STATUS'] }
    }
    else if (this.screenName == 'manage') {
      if (this.WorkflowID == 4) {
        this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'FIRST_NAME', 'LAST_NAME', 'EMAIL', 'REGION', 'ORGANIZATION', 'CURRENT_EDITOR', 'CURRENT_STATUS']
      }
      else if (this.WorkflowID == 6) {
        if (this.state.NAME == 'Completion State') {
          this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'REGION', 'Provisional School Name', 'ProvSchool_COE_NUMBER', 'CURRENT_EDITOR', 'CURRENT_STATUS']
        }
        else { this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'REGION', 'Provisional School Name', 'ProvSchool_COE_NUMBER', 'CURRENT_EDITOR'] }
      }
      else if (this.WorkflowID == 7)
        if (this.state.NAME == 'Completion State') {
          this.displayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'REGION', 'CURRENT_CITY', 'COE_NUMBER', 'CURRENT_EDITOR', 'CURRENT_STATUS']
        }
        else {
          this.displayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'REGION', 'CURRENT_CITY', 'COE_NUMBER', 'CURRENT_EDITOR']
        }
      else if (this.WorkflowID == 8)
        if (this.state.NAME == 'Completion State') {
          this.displayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'REGION', 'CURRENT_CITY', 'COE_NUMBER', 'CURRENT_EDITOR', 'CURRENT_STATUS']
        }
        else {
          this.displayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'REGION', 'CURRENT_CITY', 'COE_NUMBER', 'CURRENT_EDITOR']
        }
    }
    else {
      if (this.WorkflowID == 4) {
        this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'FIRST_NAME', 'LAST_NAME', 'EMAIL', 'REGION', 'ORGANIZATION']
      }
      else if (this.WorkflowID == 6) {
        this.displayedColumns = ['ID', 'CREATED_DATE', 'UPDATED_DATE', 'REGION', 'Provisional School Name', 'ProvSchool_COE_NUMBER']
      }
      else {
        this.displayedColumns = ['ID', 'CREATED_DATE', 'RECRUITER_NAME', 'UPDATED_DATE', 'REGION', 'CURRENT_CITY', 'COE_NUMBER']
      }
    }
  }

  loadUpdateDataSource() {
    setTimeout(() => {
      //------------------------
      if (this.workflow.ID == 8 && this.state.NAME == 'Creation State') {
        this.dataSourceSyncInitial.data = this.tblnodedata.filter(data => data.NODE_COES?.[0]?.CO?.COE_NUMBER === 'Sync Initial');
        if (this.dataSourceSyncInitial.data.length > 0) {
          // Paginator
          this.dataSourceSyncInitial.paginator = this.paginator2;

          // Sort
          if (this.sort2) {
            this.dataSourceSyncInitial.sortingDataAccessor = sortingDataAccessor;
            this.dataSourceSyncInitial.sort = this.sort2;
            const defaultSort: Sort = { active: 'CREATED_DATE', direction: 'asc' };
            this.dataSourceSyncInitial.sort.active = defaultSort.active;
            this.dataSourceSyncInitial.sort.direction = defaultSort.direction;
            this.dataSourceSyncInitial.sort.sortChange.emit(defaultSort);
          }

          // Filter
          this.dataSourceSyncInitial.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
          };
        }
      }

      if (this.workflow.ID == 8 && this.state.NAME == 'Creation State') {
        this.dataSourceWithCoeNumber.data = this.tblnodedata.filter(data => data.NODE_COES?.[0]);
        if (this.dataSourceWithCoeNumber.data.length > 0) {
          this.matTableWithCoeNumber.data = this.dataSourceWithCoeNumber.data.filter(data => data.NODE_COES[0].CO.COE_NUMBER !== 'Sync Initial');
        }
      }
      else {
        this.matTableWithCoeNumber.data = this.tblnodedata;
      }
     
      if (this.matTableWithCoeNumber.data.length > 0) {
        // Paginator
        this.matTableWithCoeNumber.paginator = this.paginator1;

        // Sort
        if (this.sort1) {
          this.matTableWithCoeNumber.sortingDataAccessor = sortingDataAccessor;
          this.matTableWithCoeNumber.sort = this.sort1;
          const defaultSort: Sort = { active: 'CREATED_DATE', direction: 'asc' };
          this.matTableWithCoeNumber.sort.active = defaultSort.active;
          this.matTableWithCoeNumber.sort.direction = defaultSort.direction;
          this.matTableWithCoeNumber.sort.sortChange.emit(defaultSort);
        }

        // Filter
        this.matTableWithCoeNumber.filterPredicate = (data: any, filter) => {
          const dataStr = JSON.stringify(data).toLowerCase();
          return dataStr.indexOf(filter) != -1;
        };
      }
    });
  }

  announceSortChange(sortState: Sort) {
    //console.log('Sort changed', sortState);
  }

  applyFilterSyncInitial(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSourceSyncInitial.filter = filterValue;
  }

  applyFilterWithCoeNumber(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.matTableWithCoeNumber.filter = filterValue;  
  }
   
  goToPage(element: WorkbenchDataView, SurveyId: number) {
    const coeId = element.NODE_COES ? element.NODE_COES[0].CO.ID : null;
    const nodeId = element.NODE_COES ? element.NODE_COES[0].NODES_ID : null;

    if (this.state.NAME == 'Creation State' && this.screenName == 'mytask') {
      if (SurveyId == 7)
        this.router.navigate(['/coe/papercoe/edit', coeId, nodeId]);
      else if (SurveyId == 2)
        this.router.navigate(['/coe/ecoe/edit', coeId, nodeId]);
    }
    else {
      if (SurveyId == 7)
        this.routeURL = '/coe/papercoe/view/' + coeId + '/' + nodeId;
      else if (SurveyId == 2)
        this.routeURL = '/coe/ecoe/view/' + coeId + '/' + nodeId;
    }
    if (this.routeURL != null && this.routeURL != '') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([this.routeURL])
      );
      window.open(this.routeURL, '_blank');
    }
  }

  goToPageView(element: WorkbenchDataView, SurveyId?: number): void {
    const coeId = element.NODE_COES ? element.NODE_COES[0].CO.ID : null;
    const nodeId = element.NODE_COES ? element.NODE_COES[0].NODES_ID : null;

    if ((this.state.NAME == 'Review State' || this.state.NAME == 'Self Review State' || this.state.NAME == 'Second Reviewer State') && (this.screenName == 'queued' || this.screenName == 'myinvolved' || this.screenName == 'myarchive' || this.screenName == 'manage'))
    {
      if (SurveyId == 7)
        this.routeURL =  '/coe/papercoe/review/view/'+ coeId + '/' + nodeId;
      else if (SurveyId == 2)
      this.routeURL =  '/coe/ecoe/review/view/'+ coeId + '/' + nodeId;
      else if (element.NODE_ACCOUNT_REQUESTS && element.NODE_ACCOUNT_REQUESTS[0])
        this.router.navigate(['/account-request/edit', element.ID]);
    }
    else{
      if (SurveyId == 7)
         this.routeURL =  '/coe/papercoe/view/' + coeId + '/' + nodeId;
      else if (SurveyId == 2)
      this.routeURL =  '/coe/ecoe/view/' + coeId + '/' + nodeId;
      else if (element.NODE_ACCOUNT_REQUESTS && element.NODE_ACCOUNT_REQUESTS[0])
        this.router.navigate(['/account-request/edit', element.ID]);
    }
    if (this.routeURL != null && this.routeURL != '') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([this.routeURL])
      );
      window.open(this.routeURL, '_blank');
    }
  }

  goToPageEdit(element: WorkbenchDataView, SurveyId: number): void {
    const coeId = element.NODE_COES[0].CO.ID;
    const nodeId = element.NODE_COES[0].NODES_ID

    if (this.state.NAME == 'Review State' || this.state.NAME == 'Self Review State' || this.state.NAME == 'Second Reviewer State') {
      if (SurveyId == 7)
        this.router.navigate(['/coe/papercoe/review/edit', coeId, nodeId]);
      else if (SurveyId == 2)
        this.router.navigate(['/coe/ecoe/review/edit', coeId, nodeId]);
      else if (element.NODE_ACCOUNT_REQUESTS && element.NODE_ACCOUNT_REQUESTS[0])
        this.router.navigate(['/account-request/edit', element.ID]);
    }
    else {
      if (SurveyId == 7)
        this.router.navigate(['/coe/papercoe/edit', coeId, nodeId]);
      else if (SurveyId == 2)
        this.router.navigate(['/coe/ecoe/edit', coeId, nodeId]);
      else if (element.NODE_ACCOUNT_REQUESTS && element.NODE_ACCOUNT_REQUESTS[0])
        this.router.navigate(['/account-request/edit', element.ID]);
    }
  }

  deleteCoe(coeId: number): void {
    this.deleteLoading = true;
    this.deleteCoeID = coeId;         
    this.nodeService.deleteCoe(coeId).subscribe((x)=> {
      let m:Msg= x['msg'];
      if(m.SUCCESS) {
        this.dataSourceSyncInitial.data = this.dataSourceSyncInitial.data.filter(item => item.NODE_COES[0].CO.ID != coeId); 
        this.deleteCoeID = 0;     
        //this.loadUpdateDataSource();
        this.workflowsService.triggerRefreshWorkbenchCounts();
      }
      else {
        this.deleteCoeID = 0;
        alert(m.MSG);        
      }
      this.deleteLoading = false;      
    });
  }

  onAddClick(element: any) {
    element.isDenied = false;
    const result = this.chooseToEditNode(element);
    if (!result) {
      element.isDenied = true;
    }
  }

  chooseToEditNode(node: Node) {
    let resultFlg: boolean = false;
    this.nodeService.chooseToEditNode(node).subscribe({
      next: (res: any) => {
        this.mesg = res.msg.MSG;
        if (res.msg.SUCCESS) {
          if (this.workflow && this.state) {
            const stateIndex = this.workflow.states.indexOf(this.state);
            this.loadUpdateDataSource();
            this.workflowsService.triggerRefreshWorkbenchCounts();
            if (this.workflow.states[stateIndex].nodes) {
              //console.log("if");
              this.workflow.states[stateIndex].nodes.splice(this.workflow.states[stateIndex].nodes.indexOf(node), 1);
            } else if (this.workflow.states[stateIndex].NODES) {
              //console.log("else if");
              this.workflow.states[stateIndex].NODES.splice(this.workflow.states[stateIndex].NODES.indexOf(node), 1);
            }
          }
          else if (this.workflow && !this.state) {
            //console.log("outer else if");
            this.workflow.nodes.splice(this.workflow.nodes.indexOf(node), 1);
          }
          if (!this.noReload) {
            //console.log("noReload");
            this.router.navigateByUrl(this.router.url); // Equivalent to $route.reload()
          }
        }
      },
      error: (err: any) => {
        alert('Error while fetching the records');
        console.log('error while getting organization data');
      }
    });
    return resultFlg ;
  }

  ChooseToNotEditNode(node: Node) {
    this.nodeService.ChooseToNotEditNode(node).subscribe({
      next: (res: any) => {
        this.mesg = res.msg.MSG;
        if (this.workflow && this.state) {
          const stateIndex = this.workflow.states.indexOf(this.state);
          this.loadUpdateDataSource();
          this.workflowsService.triggerRefreshWorkbenchCounts();
          if (this.workflow.states[stateIndex].nodes) {
            this.workflow.states[stateIndex].nodes.splice(this.workflow.states[stateIndex].nodes.indexOf(node), 1);
          } else if (this.workflow.states[stateIndex].NODES) {
            this.workflow.states[stateIndex].NODES.splice(this.workflow.states[stateIndex].NODES.indexOf(node), 1);
          }
        }
        else if (this.workflow && !this.state) {
          this.workflow.nodes.splice(this.workflow.nodes.indexOf(node), 1);
        }
        /*if (node?.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS){
           this.accountRequestService.releaseControlAccountRequest(this.state.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS).subscribe({
             next: (res: any) => {
               console.log("res", res)
               this.mesg  = res.msg.MSG;
             }
           })
         }*/
        if (!this.noReload) {
          console.log("noReload");
          this.router.navigateByUrl(this.router.url); // Equivalent to $route.reload()
        }
      },
      error: (err: any) => {
        alert('Error while fetching the records');
        console.log('error while getting organization data');
      }
    });
  }
  
  goToAssignNode(node: Node, option: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = node;
    dialogConfig.maxHeight = '79vh';
    dialogConfig.minWidth = '70vw';
    let dialogRef: any;
    if (option == 'assign') {
      dialogRef = this.dialog.open(ReassignChangeNodeStateComponent, dialogConfig);
    } else if (option == 'change') {
      dialogRef = this.dialog.open(ChangeNodeComponent, dialogConfig);
    }

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {

      }
    });
  }

  titleText(text: string): string {
    // Implement your title text formatting logic here
    return text; // Replace with actual formatted text
  }
}
